<div id="role-popup" class="common-popup-block-doc pop-overrider">

    <form class="form" role="form" [formGroup]="userRoleForm" autocomplete="off">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Añadir nuevo rol</h2>
        </div>

        <div class="popoup-content">
            <div class="form-wrap-wrp">
                <div class="form-wrap full-new-field">
                    <mat-form-field appearance="fill">
                        <mat-select placeholder="Seleccione" formControlName="rolId">
                            <mat-option disabled>Seleccione</mat-option>
                            <mat-option *ngFor="let otherRole of otherRolesList" [value]="otherRole.value">
                                {{ otherRole.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="popoup-footer">
            <button class="keep" (click)="submit()"> <span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel(false)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form> 
</div>